interface Props {
  size?: number;
  className?: string;
}

/**
 * Material Design "delete" icon — same one the tablet uses (`MdDelete` from
 * react-icons/md). Inlined as SVG so we don't pull in the icon library.
 */
export const BinIcon = ({ size = 16, className }: Props): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);
